import { composeConfigs, PreviewWeb } from '@storybook/preview-web';
    import { ClientApi } from '@storybook/client-api';
    import '/virtual:/@storybook/builder-vite/setup-addons.js';
    import { importFn } from '/virtual:/@storybook/builder-vite/storybook-stories.js';

    const getProjectAnnotations = async () =>
      composeConfigs(await Promise.all([import('@storybook/vue3/dist/esm/client/preview/config'),
import('@storybook/vue3/dist/esm/client/docs/config'),
import('@storybook/addon-links/preview.js'),
import('@storybook/addon-docs/preview.js'),
import('@storybook/addon-actions/preview.js'),
import('@storybook/addon-backgrounds/preview.js'),
import('@storybook/addon-measure/preview.js'),
import('@storybook/addon-outline/preview.js'),
import('@storybook/addon-interactions/preview.js'),
import('@whitespace/storybook-addon-html/out/preset/addDecorators.js'),
import('/Users/matthias.noetzli/Dev/hfh-styleguide/.storybook/preview.js')]));

    const preview = new PreviewWeb();

    window.__STORYBOOK_PREVIEW__ = preview;
    window.__STORYBOOK_STORY_STORE__ = preview.storyStore;
    window.__STORYBOOK_CLIENT_API__ = new ClientApi({ storyStore: preview.storyStore });

    preview.initialize({ importFn, getProjectAnnotations });
    
    if (import.meta.hot) {
      import.meta.hot.accept('/virtual:/@storybook/builder-vite/storybook-stories.js', (newModule) => {
      // importFn has changed so we need to patch the new one in
      preview.onStoriesChanged({ importFn: newModule.importFn });
      });

    import.meta.hot.accept(["@storybook/vue3/dist/esm/client/preview/config","@storybook/vue3/dist/esm/client/docs/config","@storybook/addon-links/preview.js","@storybook/addon-docs/preview.js","@storybook/addon-actions/preview.js","@storybook/addon-backgrounds/preview.js","@storybook/addon-measure/preview.js","@storybook/addon-outline/preview.js","@storybook/addon-interactions/preview.js","@whitespace/storybook-addon-html/out/preset/addDecorators.js","/Users/matthias.noetzli/Dev/hfh-styleguide/.storybook/preview.js"], ([...newConfigEntries]) => {
      const newGetProjectAnnotations =  () => composeConfigs(newConfigEntries);

      // getProjectAnnotations has changed so we need to patch the new one in
      preview.onGetProjectAnnotationsChanged({ getProjectAnnotations: newGetProjectAnnotations });
    });
  };